(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  function updateAnnouncementBarHeight() {
    var bar = document.querySelector('#shopify-section-announcement-bar');
    var height = bar ? bar.offsetHeight : 0;
    if (document && document.body) {
      document.body.style.setProperty('--announcement-bar-height', height + 'px');
    }
  }
  document.addEventListener('DOMContentLoaded', updateAnnouncementBarHeight);
  window.addEventListener('resize', updateAnnouncementBarHeight);

  } catch(e) { console.error(e); }
})();
})();
